import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loading: false,
	expenseCategories: [],
	paymentMethods: [],
	currencies: []
};

export default function enumDataReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_ENUM_DATA_REQUEST:
		case ActionTypes.GET_ENUM_DATA_ERROR:
		case ActionTypes.GET_ENUM_DATA_SUCCESS:
			return {
				...state,
				...action.payload
			};
		default:
			return state;
	}
}
